import { StyleSheet } from "react-native";

// Theme tokens — faithful to /Users/admin/dev/project/constants/theme.ts.
// The values live in the shared @components/ds/tokens; this feature keeps its
// own names for the two it disagrees on (textPrimary, primary).
import { tokens as dsTokens, cardElevation } from "@components/ds/tokens";

export { cardElevation };

export const tokens = {
  ...dsTokens,
  textPrimary: dsTokens.textHeading,
  primary: dsTokens.accent,
  // OFD pill (multi-trip trip cards, #2136); not in the shared tokens.
  pill: {
    ...dsTokens.pill,
    ofd: { bg: "#EEF2FF", fg: "#4338CA", border: "#4338CA" },
  },
};

export const sharedStyles = StyleSheet.create({
  flex1: { flex: 1 },
  screen: { flex: 1, backgroundColor: tokens.bg },
  centered: { flex: 1, alignItems: "center", justifyContent: "center" },

  card: {
    backgroundColor: tokens.surface,
    borderRadius: tokens.radius.lg,
    padding: tokens.spacing.large,
    marginHorizontal: tokens.spacing.page,
    marginBottom: tokens.spacing.medium,
    ...cardElevation,
  },

  rowSpread: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  pillBase: {
    paddingHorizontal: tokens.spacing.medium,
    paddingVertical: 6,
    borderRadius: tokens.radius.full,
    borderWidth: 1,
    marginRight: 6,
    marginBottom: 6,
    alignSelf: "flex-start",
  },
  pillText: { fontSize: 12, fontWeight: "600" },

  emptyText: {
    color: tokens.textTertiary,
    textAlign: "center",
    marginTop: 60,
    fontSize: 14,
  },

  permissionMsg: {
    color: tokens.textPrimary,
    marginHorizontal: 24,
    textAlign: "center",
  },
});
